
import {Mixins, Component,Prop} from 'vue-property-decorator';
import Dates from "@/components/inputs/Dates.vue";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import {MahkemeBirimleriRow} from "@/plugins/uyap-plugin/uyap/CommonInterfaces";

@Component({
  components: {Dates}
})
export default class DetayliAramaPanel extends Mixins(SimpleInputMixin) {
  @Prop() icraDaireleri!: Array<MahkemeBirimleriRow>;
  @Prop() uyapTakipLoadStatus!: any;

  yilListesi = Array.from({length: 20}, (_, i) => new Date().getFullYear() - i);
  isOpen: boolean = false;

  togglePanel(){
    this.isOpen = !this.isOpen;
  }

  filtreleriTemizle(){
    this.localValue.secilenIcraDairesi = undefined;

    // Kişi ve kurum bilgilerini temizle
    this.localValue.tcKimlikNo = '';
    this.localValue.adi = '';
    this.localValue.soyadi = '';
    this.localValue.kurumAdi = '';
    this.localValue.mersisNo = '';
    this.localValue.vergiNo = '';

    // Tarih bilgilerini temizle
    this.localValue.baslangicTarihi = '';
    this.localValue.bitisTarihi = '';

    // Dosya bilgilerini temizle - dosyaSira2 eklendi
    this.localValue.dosyaYil = undefined;
    this.localValue.dosyaSira = undefined;
    this.localValue.dosyaSira2 = undefined; // Bu satır eksikti

    // Filtrelenmiş tabloyu temizle
    this.$emit('filtreleriTemizle');

    // Input değişikliğini tetikle
    this.input();
  }

  filtreleriUygula(){
    this.$emit('filtreleriUygula')
  }
}
